<!-- template.component.html -->

<!-- LOADING MODAL OVERLAY -->
<div class="loading-overlay" *ngIf="isLoading">
  <div class="loading-modal">
    <div class="spinner-border" role="status">
      <span class="visually-hidden"></span>
    </div>
    <h4 class="mt-3">Processing Analysis</h4>
    <p class="mt-2">{{ loadingMessage }}</p>

    <!-- Optional: Progress Bar visiva -->
    <div class="progress mt-3" style="height: 5px;">
      <div class="progress-bar progress-bar-striped progress-bar-animated"
           role="progressbar"
           [style.width]="loadingProgress + '%'"></div>
    </div>
  </div>
</div>

<div class="container-fluid mt-3 mb-5">

  <!-- Analysis Generation Section (moved from ScenarioGeneratorComponent) -->
  <div class="row mb-1">
    <div class="col text-center">
      <button class="btn nav-btn mx-auto"
              (click)="generateAnalysisOnly()"
              [disabled]="isLoading">
        <span class="spinner-border spinner-border-sm me-2" *ngIf="isLoading" role="status" aria-hidden="true"></span>
        <i class="fa fa-play me-2" *ngIf="!isLoading"></i>
        <span>Begin Analysis</span>
      </button>
    </div>
  </div>

  <div class="row mb-4">
    <div class="col text-center">
      <div class="form-check form-switch d-inline-block">
        <input class="form-check-input" type="checkbox" role="switch" id="lookForAmbiguitiesSwitch"
               [(ngModel)]="lookForAmbiguitiesInAnalysis" [disabled]="isLoading">
        <label class="form-check-label small" for="lookForAmbiguitiesSwitch">Look for Ambiguities</label>
      </div>
      <div *ngIf="error && !isLoading" class="alert alert-danger mt-2 small p-2 mx-auto" style="max-width: 400px;">
        {{ error }}
      </div>
    </div>
  </div>

  <div class="row mb-2" *ngIf="!isLoading && coreAnalysis">
    <div class="col text-center">
      <div class="btn-group" role="group">
        <button class="btn btn-outline-success btn-sm"
                (click)="generateRequirementsAnalysisOnly()"
                [disabled]="isLoading">
          <i class="fa fa-list me-1"></i>
          Generate Requirements Analysis
        </button>
      </div>
    </div>
  </div>

  <!-- Analysis Debug Section -->
  <div class="debug-section mb-3" *ngIf="coreAnalysis || requirementsAnalysis">
    <div class="card">
      <div class="card-header d-flex justify-content-between align-items-center"
           (click)="isDebugVisible = !isDebugVisible"
           role="button"
           [attr.aria-expanded]="isDebugVisible">
        <h3 class="h5 mb-0">Scriptor's Context Analysis</h3>
        <!-- Button Group for Save and Toggle Visibility -->
        <div>
          <button class="btn btn-sm btn-outline-primary mr-2"
                  (click)="saveAnalysisChanges(); $event.stopPropagation()"
                  [disabled]="!coreAnalysis"
                  title="Save manual changes to the analysis below">
            <i class="fa fa-save me-1"></i> Save Changes
          </button>
          <button class="btn btn-sm btn-outline-secondary" type="button" tabindex="-1">
            <i class="fa" [ngClass]="isDebugVisible ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
          </button>
        </div>
      </div>
      <div class="card-body p-3" *ngIf="isDebugVisible">

        <!-- Core Analysis (Editable) -->
        <div class="debug-content mb-3" *ngIf="coreAnalysis">
          <h4 class="h6 text-primary">Core Analysis</h4>
          <div class="mb-2">
            <h5 class="h6 text-secondary small">Functional Analysis</h5>
            <textarea class="form-control debug-code-editor"
                      appTextareaAutosize
                      [(ngModel)]="coreAnalysis.scenario_analysis"
                      placeholder="Functional analysis content..."></textarea>
          </div>
          <div *ngIf="coreAnalysis?.config_testdata_analysis">
            <h5 class="h6 text-secondary small">Configuration & Test Data Analysis</h5>
            <textarea class="form-control debug-code-editor"
                      appTextareaAutosize
                      [(ngModel)]="coreAnalysis.config_testdata_analysis"
                      placeholder="Configuration and test data analysis content..."></textarea>
          </div>
        </div>

        <!-- ✅ SEZIONE NUOVA: Extracted Constraints (Read-only) -->
        <div class="debug-content mb-3" *ngIf="extractedConstraints && extractedConstraints.length > 0">
          <h4 class="h6 text-primary mt-3">Extracted Constraints</h4>
          <div class="constraints-list">
            <ul class="list-group list-group-flush">
              <!-- Itera sulla lista di vincoli e mostra ciascuno -->
              <li class="list-group-item small py-2" *ngFor="let constraint of extractedConstraints">
                <i class="fa fa-lock me-2 text-muted"></i> <!-- Icona per dare un tocco visivo -->
                {{ constraint.description }}
              </li>
            </ul>
          </div>
        </div>
        <!-- ✅ FINE SEZIONE NUOVA -->

        <!-- Requirements Analysis (Editable) -->
        <div class="debug-content mb-3" *ngIf="requirementsAnalysis">
          <h4 class="h6 text-primary mt-3">Requirements Analysis</h4>
          <div class="mb-2">
            <h5 class="h6 text-secondary small">Detailed Requirements</h5>
            <textarea class="form-control debug-code-editor"
                      appTextareaAutosize
                      [(ngModel)]="requirementsAnalysis.scenario_analysis"
                      placeholder="Detailed requirements content..."></textarea>
          </div>
          <div *ngIf="requirementsAnalysis?.config_testdata_analysis">
            <h5 class="h6 text-secondary small">Configuration & Test Data Analysis</h5>
            <textarea class="form-control debug-code-editor"
                      appTextareaAutosize
                      [(ngModel)]="requirementsAnalysis.config_testdata_analysis"
                      placeholder="Configuration and test data analysis content..."></textarea>
          </div>
        </div>

        <!-- Supportive Analysis (Editable) -->
        <div class="debug-content" *ngIf="supportiveAnalysis">
          <h4 class="h6 text-primary mt-3">Supportive Analysis</h4>
          <div class="mb-2" *ngIf="supportiveAnalysis?.scenario_enrichments">
            <h5 class="h6 text-secondary small">Scenario Enrichments</h5>
            <textarea class="form-control debug-code-editor"
                      rows="8"
                      [(ngModel)]="supportiveAnalysis.scenario_enrichments"
                      placeholder="Scenario enrichments content..."></textarea>
          </div>
          <div *ngIf="supportiveAnalysis?.config_testdata_enrichments">
            <h5 class="h6 text-secondary small">Configuration & Test Data Enrichments</h5>
            <textarea class="form-control debug-code-editor"
                      rows="8"
                      [(ngModel)]="supportiveAnalysis.config_testdata_enrichments"
                      placeholder="Configuration and test data enrichments content..."></textarea>
          </div>
        </div>

      </div>
    </div>
  </div>

  <!-- Trace Matrix and Data Parameters -->
  <div *ngIf="coreAnalysis?.scenario_analysis" class="trace-matrix-section">
    <app-trace-matrix></app-trace-matrix>
  </div>

  <div *ngIf="coreAnalysis" class="mt-3">
    <app-data-param-table></app-data-param-table>
  </div>

  <!-- THREE COLUMN WORKSPACE COMPONENT -->
  <app-three-column-workspace
    [projectId]="projectId"
    [refinedStoryString]="refinedStoryString"
    [projectLanguage]="projectLanguage"
    (dataChanged)="onWorkspaceDataChanged()"
    (checkpointSaved)="onWorkspaceCheckpointSaved($event)"
    (macroScenariosGenerated)="onMacroScenariosGenerated($event)">
  </app-three-column-workspace>

  <div class="row mb-2" *ngIf="isLoading">
    <div class="col text-center">
      <div class="small text-muted">
        <span *ngIf="!coreAnalysis && !requirementsAnalysis">Generating core analysis...</span>
        <span *ngIf="coreAnalysis && !requirementsAnalysis">Core analysis complete. Generating requirements analysis...</span>
      </div>
    </div>
  </div>

  <!-- Error Alert -->
  <div class="alert alert-danger mt-3" *ngIf="error">
    {{ error }}
  </div>

</div>
